const contacts = [
    {
      id: "1",
      name: "Toàn bộ căn nhà",
      imgURL:
        "https://i.pinimg.com/564x/99/03/39/99033994e792d3a5435278e6b32f868f.jpg",
      tel: "0823996913",
      email: "phuvietdang@gmail.com",
      description:"In ancient manuscripts, another means to divide sentences into paragraphs was a line break (newline) followed by an initial at the beginning of the next paragraph. An initial is an oversized capital letter, sometimes outdented beyond the margin of the text."
     
    },
  
    {
      id: "2",
      name: "Cabin & hoang dã",
      imgURL:"https://i.pinimg.com/564x/53/a5/99/53a5999bae9b1b8de2c72a7d83ee7106.jpg",
      tel: "0823996913",
      email: "phuvietdang@gmail.com",
      description:"In ancient manuscripts, another means to divide sentences into paragraphs was a line break (newline) followed by an initial at the beginning of the next paragraph. An initial is an oversized capital letter, sometimes outdented beyond the margin of the text."

    },
  
    {
      id: "3",
      name: "Tiện nghi độc đáo",
      imgURL:
        "https://i.pinimg.com/564x/20/c9/1c/20c91cae399391947d3f0b39ce704263.jpg",
      tel: "0823996913",
      email: "phuvietdang@gmail.com",
      description:"In ancient manuscripts, another means to divide sentences into paragraphs was a line break (newline) followed by an initial at the beginning of the next paragraph. An initial is an oversized capital letter, sometimes outdented beyond the margin of the text."

    },
    {
      id: "4",
      name: "Cho phép thú cưng",
      imgURL:
        "https://i.pinimg.com/564x/91/b9/2d/91b92d313d867dad54725ba7400b7852.jpg",
      tel: "0823996913",
      email: "phuvietdang@gmail.com",
      description:"In ancient manuscripts, another means to divide sentences into paragraphs was a line break (newline) followed by an initial at the beginning of the next paragraph. An initial is an oversized capital letter, sometimes outdented beyond the margin of the text."

    },
  ];
  
  export default contacts;
  